module.exports = __webpack_public_path__ + "img/kontakt_3000.cbd97232.png";